<template>
  <div class="disease-detail-main-container">
    <ReturnButton></ReturnButton>
    <HomeButton v-if="isInternal"></HomeButton>
    <div class="jingluo-detail-main-content">
      <div class="jingluo-detail-title-image-area">
        <img :src="require(`@/assets/image/jingLuoPage/jingluoImg/${titleUrl}.jpg`)" class="jingluo-detail-title-image">
      </div>
      <div class="jingluo-detail-title-text-area">
        <span class="jingluo-detail-main-content-xuewei">{{ xueweiName }}</span>
        <span class="jingluo-detail-main-content-jingluo">{{ "(" + jingluoName + ")" }}</span>
      </div>
      <div class="jingluo-detail-title-detail-area">
        <div class="jingluo-detail-title-detail-area-border">
          <div class="jingluo-detail-title-detail-title">{{ detailTitle }}</div>
          <div class="jingluo-detail-title-detail-description">{{ detailDescription }}</div>
          <div class="jingluo-detail-title-detail-info">
            <div class="jingluo-detail-title-detail-info-title">
              【主 治】：
            </div>
            <div class="jingluo-detail-title-detail-info-description">
              {{ cure }}
            </div>
          </div>
          <div class="jingluo-detail-title-detail-info">
            <div class="jingluo-detail-title-detail-info-title">
              【定 位】：
            </div>
            <div class="jingluo-detail-title-detail-info-description">
              {{ position }}
            </div>
          </div>
          <div class="jingluo-detail-title-detail-info">
            <div class="jingluo-detail-title-detail-info-title">
              【快速取穴】：
            </div>
            <div class="jingluo-detail-title-detail-info-description">
              {{ quickFind }}
            </div>
          </div>
          <div class="jingluo-detail-title-detail-info">
            <div class="jingluo-detail-title-detail-info-title">
              【保健按摩】：
            </div>
            <div class="jingluo-detail-title-detail-info-description">
              {{ massage }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ReturnButton from "@/components/ReturnButton";
import HomeButton from "@/components/HomeButton";
import CommonData from "@/assets/js/CommonData";

export default {
  name: 'JingluoDetailPage',
  components: {
    HomeButton,
    ReturnButton,
  },
  data() {
    return {
      titleUrl: "",
      xueweiName: '少海穴',
      jingluoName: '手少阴心经',
      detailTitle: '少海穴：感冒咽痛不再烦',
      detailDescription: '少，幼小、微小之意；商，古代五音之一，属金，属肺。少商，是商的高音，意为金气所止或为金气初生之处也。',
      cure: '泻热开窍，通利咽喉。咳嗽、咽喉肿痛、慢性咽炎、扁桃体炎、 中风昏迷、小儿惊风、热病、中暑、感冒。',
      position: '在手指，拇指末端桡侧，指甲根角侧上方0.1寸。',
      quickFind: '一手拇指伸直，另手拇、食指轻握，拇指弯曲掐按伸直的拇指指甲角边缘处即使。',
      massage: '用指甲使劲掐一掐少商，可以减少咽喉肿痛的症状。打嗝时，用拇指按压少商，以感觉酸度为度，持续半分钟，即可止戈。'
    };
  },
  methods: {},
  created() {
    let currentXueweiIndex = this.currentXueweiIndex = this.$route.query.currentXueweiIndex;
    let currentJingMaiIndex = this.currentJingMaiIndex = this.$route.query.currentJingMaiIndex;
    this.isInternal = this.$route.query.internal !== "false";
    let jingMaiObj = JSON.parse(JSON.stringify(CommonData.jingmaiList[currentJingMaiIndex]));
    let xueweiObj = jingMaiObj.xueweiList[currentXueweiIndex];
    this.jingluoName = jingMaiObj.jingMaiName;
    this.xueweiName = xueweiObj.xueweiName;
    let {titleUrl, detailTitle, detailDescription, cure, position, quickFind, massage,} = xueweiObj.xueweiDetail;
    this.titleUrl = titleUrl;
    this.detailTitle = detailTitle;
    this.detailDescription = detailDescription;
    this.cure = cure;
    this.position = position;
    this.quickFind = quickFind;
    this.massage = massage;
    // let keShiObj = this.keShiList[keShiCode];
    // this.keShiName = keShiObj.name;
  },
  destroyed() {
  }
}
</script>

<style>
.jingluo-detail-main-content {
  font-family: "PingFang", serif;
  font-size: 4vw;
  color: #c8c8c8;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.jingluo-detail-title-image-area {
  background-image: url("../assets/image/jingLuoPage/TitleImgBorder.png");
  background-size: 100% 100%;
  border: 0;
  height: 38.4vw;
  width: 39.3vw;
  margin-top: 9vh;
}

.jingluo-detail-title-image {
  width: 96%;
  height: 96%;
  margin: 0.7vw;
  border-radius: 1.5vw;
}

.jingluo-detail-title-text-area {
  display: flex;
  flex-direction: column;
  margin-top: 2vh;
}

.jingluo-detail-main-content-xuewei {
  font-size: 5.5vw;
  color: #0fffff;
}

.jingluo-detail-main-content-jingluo {
  font-size: 4.2vw;
}

.jingluo-detail-title-detail-area {
  background-image: url("../assets/image/jingLuoPage/JingLuoDetailInfoBg.png");
  background-size: 100% 100%;
  border: 0;
  height: 92.7vw;
  margin-top: 2vh;
  width: 64%;
  padding: 0 5.5vw 0 5.5vw;
  text-align: left;
  font-size: 2.5vw;
}

.jingluo-detail-title-detail-area-border {
  overflow: scroll;
  height: 83vw;
  margin-top: 2vh;
}

.jingluo-detail-title-detail-title {
  font-size: 4.45vw;
  color: #0fffff;
  border-bottom: dashed 0.3vw;
  border-bottom-color: #c8c8c8;
  padding: 1vh 0 0.7vw 0;
}

.jingluo-detail-title-detail-description {
  margin: 1vh 0 2vh 0;
}

.jingluo-detail-title-detail-info-title {
  color: #0fffff;
}

.jingluo-detail-title-detail-info {
  margin-top: 0.5rem;
}
</style>
